import { baseState, baseMutations } from "@/store/mixins";
import firstCyclePaid from "@/api//payroll/first-cycle-paid";

export const state = {
    ...baseState,
};
export const getters={};

export const mutations = {
    ...baseMutations,
};
export const actions = {
    store(context, data) {
        return firstCyclePaid.store(data);
    }, 
    fetch(context, attributes = {}) {
        const params = Object.assign(
            {
                page: context.state.pagination.page,
                perPage: context.state.pagination.perPage,
                filter: {
                    search: context.state.search
                }
            },
            attributes
        );
        return firstCyclePaid.get({ params }).then(response => {
            context.commit("RECEIVE_RESOURCES", response);
            return Promise.resolve(response);
        });
    }, 
    update(context, { id, data }) {
        return firstCyclePaid.update(id, data);
    },
    remove(context, data) {
        return firstCyclePaid.remove(data);
    },
}